// LocaleDateFormatter/fr.ts
import type { Translations } from './translationsTypes';

const fr: Translations = {
    Hour: 'HH',
    Min: 'mm',
    Day: 'dd',
    Month: 'MMMM',
    Extend: 'a',
    HourMin: 'HH:mm',
    HourMinSecond: 'HH:mm:ss',
    HourMinFull: 'HH:mm:ss ZZZZ',
    Trunc: 'd MMM yyyy',
    Date: 'd MMMM yyyy',
    Classic: 'dd-MM-yyyy',
    DateGlobal: 'dd-MM-yyyy',
    TimeSpecial: '{HOUR}h{MIN}',
    UTC: 'ZZZZ',
    AdfDayMonth: '{DAY} {MONTH}',
    AdfTimeDate: 'à {TIME} le {DATE}',
    AdfDateTime: 'le {DATE} à {TIME}',
    AdfTime: '{TIME} le {DATE}',
    AdfDate: '{DATE} à {TIME}',
};

export default fr;
